import type { ReactNode } from 'react';

// =====================================================================
// PageContainer — the ONE content column for every panel screen (design
// audit 2026-08-28, finding P1-9: five different gutters shipped at once,
// 288/324/348/388/460 px, because every route hand-rolled its own
// `mx-auto max-w-{2xl,3xl,4xl,5xl}` wrapper).
//
// Operator decision (2026-08-28): ONE content width, `max-w-4xl`. A form
// card may still narrow ITSELF to `max-w-3xl` INSIDE this container — the
// page column does not change.
//
// Deliberately takes no `className`: the whole point of this primitive is
// that a route cannot quietly pick a different width again. Spacing between
// the header and the body is the fixed `gap-6` below. Horizontal padding is
// NOT set here — panel-shell.tsx's `<main className="flex-1 px-6 py-8">`
// already owns the page gutter, and the org-level screens that self-mount
// PanelShell used to double it (settings/billing/locations/surveys added
// their own `px-6 py-8` inside main's, which is where the audit's "Settings
// column offset 72 px" came from).
// =====================================================================

interface PageContainerProps {
  children: ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  return <div className="mx-auto flex w-full max-w-4xl flex-col gap-6">{children}</div>;
}
